export const buttons = {
    github:{
        eng:'My GitHub',
        pl:'Mój GitHub'
    }
}

export const theme = {
    main_blue:'#17293F'
}